import { Box } from "@mui/material";
import ConsumerMoveSummary from "./consumerMoveSummary/ConsumerMoveSummary";
import CountDown from "./countdown/CountDown";
import ConsumerNavbar from "./navbar/ConsumerNavbar";
import MoveReminder from "./moveReminder/MoveReminder";
import MovingCompanyInfo from "./movingCompanyInfo/MovingCompanyInfo";
import MoveSchedule from "./moveSchedule/MoveSchedule";
import MovingTips from "./movingTips/MovingTips";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getConsumer } from "../redux/action/otp";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

const ConsumerDashboard = () => {
  const { canonicalId, carrierCanonicalId } = useParams();
  const dispatch = useDispatch();
  const [user, setUser] = useState<any>(null);
  const [moves, setMovesData] = useState<any>(null);
  const [error, setError] = useState("");

  const [selectedMoveServiceData, setSelectedMoveServiceData] =
    useState<any>(null);
  const [movingDate, setMovingDate] = useState<string>("");
  const getUser = () => {
    if (!carrierCanonicalId) {
      setError("Carrier ID is missing");
      return;
    }
    if (!canonicalId) {
      setError("user id is missing");
      return;
    }
    dispatch<any>(getConsumer({ canonicalId, carrierCanonicalId }))
      .then(unwrapResult)
      .then((res: any) => {
        setUser(res);
        setMovesData(res.moveServices);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (canonicalId && !user) getUser();
  }, [canonicalId]);
  const handleMoveSelection = (moveData: any) => {
    setSelectedMoveServiceData(moveData);
    if (moveData?.moving_date) {
      setMovingDate(new Date(moveData.moving_date).toISOString());
    }
  };
  const move = {
    pickupDate: movingDate || "2025-05-11T00:00:00Z",
  };
  const [refreshKey, setRefreshKey] = useState(0);
  const refreshMoveData = () => {
    setRefreshKey((prev) => prev + 1);
  };
  return (
    <>
      <ConsumerNavbar user={user} />
      <Box sx={{ margin: "25px" }}>
        {selectedMoveServiceData ? <CountDown move={move} /> : null}
        <ConsumerMoveSummary
          onMoveSelect={handleMoveSelection}
          selectedMoveServiceData={selectedMoveServiceData}
          user={user}
        />
        {/* <MoveReminder /> */}
        <MovingCompanyInfo moves={moves} />
        <MoveSchedule
          selectedMoveServiceData={selectedMoveServiceData}
          refreshMoveData={refreshMoveData}
        />
        <MovingTips />
      </Box>
    </>
  );
};

export default ConsumerDashboard;
